import { ChakraTheme, DeepPartial, extendTheme } from "@chakra-ui/react";

// App-level theme = the landing (marketing) theme, merged in from the
// standalone lovelica-landing app. Funnel pages are unaffected: each funnel
// mounts its own ChakraProvider with its own theme via PageConfigProvider.

/**
 * Brand mauve, identical to the webapp's `brand` scale (app-monorepo
 * `apps/lovelica/src/theme.ts`). 400 is the call-to-action colour; the light
 * steps carry extra saturation so an accent label (brand.200) still reads as
 * colour on the dark landing.
 */
export const brand = {
  50: "#F5EFF5",
  100: "#EDC9ED",
  200: "#E3ABE2",
  300: "#CD84CC",
  400: "#A46CA3",
  500: "#8F528D",
  600: "#714171",
  700: "#543054",
  800: "#3A213A",
  900: "#241423",
};

// Legacy accent of the light landing; still referenced by the bank checkout
// theme re-export, so it stays in the palette.
export const primary = {
  50: "#fff1f0",
  100: "#ffdfdd",
  200: "#ffc4c0",
  300: "#ff9b94",
  400: "#ff6257",
  500: "#ff3123",
  600: "#ff291a",
  700: "#d70e00",
  800: "#b10e03",
  900: "#92130a",
  950: "#500500",
};

export const secondary = {
  50: "#E4F8EF",
  100: "#CDF3E3",
  200: "#A8E4CA",
  300: "#98CEB7",
  400: "#7FAD99",
  500: "#688E7E",
  600: "#527164",
  700: "#3D554B",
  800: "#273831",
  900: "#15201B",
};

export const bg = {
  50: "#FAF9FA",
  100: "#F6F4F6",
  200: "#EDE8ED",
  300: "#E6E0E6",
  400: "#DDD4DD",
  500: "#BEACBE",
  600: "#9E859E",
  700: "#785F78",
  800: "#503F50",
  900: "#282028",
};

export const text = {
  main: "black",
  invert: "white",
  50: "#eceffe",
  100: "#d3d6e1",
  200: "#b8bbc7",
  300: "#9da1af",
  400: "#828897",
  500: "#686e7d",
  600: "#505762",
  700: "#383d47",
  800: "#20232d",
  900: "#060916",
};

export const theme: DeepPartial<ChakraTheme> = extendTheme({
  fonts: {
    heading: "Inter Variable, sans-serif",
    body: "Inter Variable, sans-serif",
  },
  colors: {
    brand,
    primary,
    secondary,
    bg,
    text,
  },
});

export default theme;
